import { transition } from '@helpers/animate';
import { Device, until } from '@helpers/media';
import svgTick from '@img/icons/icon-tick-background.svg';
import styled from 'styled-components';
const Container = styled.ul `
  ${transition('opacity')}

  display: flex;
  flex: 1 1 50%;
  flex-direction: column;

  &[data-active='false'] {
    opacity: 0.6;

    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }

  &[data-active='true'] {
    opacity: 1;
  }
`;
const Item = styled.li `
  display: flex;
  align-items: center;

  &::before {
    content: '';
    display: flex;
    background: url('${svgTick}');
    background-size: 26px;
    flex: 0 0 auto;
    height: 26px;
    margin: 0 16px 0 0;
    place-content: center;
    place-items: center;
    width: 26px;
  }

  &:not(:last-child) {
    margin: 0 0 16px;
  }
`;
const FeatureListStyles = {
    Container,
    Item,
};
export default FeatureListStyles;
